import "core-js/modules/es.array.includes.js";
import styled, { css } from "styled-components";
import { borderColor, color, fontSize, position as positionEnhancer } from "../core/enhancers";
var Spinner = styled.div.withConfig({
  displayName: "Spinner",
  componentId: "sc-ihn9q5-0"
})(["box-sizing:border-box;display:inline-block;width:1em;height:1em;border-radius:50%;border-style:solid;border-width:0.15em;border-color:rgba(255,255,255,0.2);animation:rotate 1.1s infinite linear;@keyframes rotate{100%{transform:rotate(360deg);}}", ";", ";", ";", ";", ";border-left-color:currentColor;"], function (_ref) {
  var theme = _ref.theme,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "dark" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "m" : _ref$size,
      position = _ref.position,
      zIndex = _ref.zIndex;
  return css(["color:", ";border-color:", ";font-size:", ";z-index:", ";", ";"], theme.componentsTokens.spinner.variants[variant].fg, theme.componentsTokens.spinner.variants[variant].bg, theme.componentsTokens.spinner.sizes[size], zIndex || "auto", position && ["absolute", "fixed"].includes(position) && css(["top:calc(50% - 0.5em);left:calc(50% - 0.5em);"]));
}, fontSize, color, borderColor, positionEnhancer);
export default Spinner;